<template>
  <div
    class="supernavbar-host"
    :class="{'under-top-banner':topBannerShown}"
  >
    <div class="host-header">
      <img
        :src="cafe.image || '/icons/navbar-qrwaiter-logo.svg'"
        class="host-header-logo"
        :class="{
          active: isCafeSwitcherShown,
        }"
        alt="Cafe Logo"
        @click="$emit('cafeClicked')"
      />
    </div>
    <div class="host-content">
      <div class="host-pages">
        <NavbarHostButton
          v-for="page in pages"
          :key="page.name"
          :page="page"
          :selectedPage="selectedPage"
          @click="$emit('routeClicked', page)"
        />
      </div>
      <div class="host-footer">
        <NavbarHostButton
          :page="{ icon: 'currency-dollar-circle-filled', constantRoute:'superbilling', activeIcon: 'currency-dollar-circle', name: 'superbilling'}"
          @click="$emit('billingClicked')"
        />
        <NavbarHostButton
          :page="{ icon: 'marketplace', name: 'integrations',
          constantRoute: 'integrations'
          ,}"
          @click="$emit('marketplaceClicked')"
        />
        <div class="host-footer-divider-container">
          <BaseDivider color="border-base-inverse-tertiary" />
        </div>

        <div class="host-footer-user">
          <div
            class="host-user-icon qrw-user-avatar qrw-label-md bold"
            :class="{
              active: isProfileShown
            }"
            @click="$emit('userClicked')"
          >
            {{ userNameInitials }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarHostButton from './NavbarHostButton.vue'

export default {
  props: {
    pages: Array,
    selectedPage: Object,
    topBannerShown: Boolean
  },
  computed: {
    cafe() {
      return this.$store.state.cafe
    },
    owner() {
      return this.$store.state.owner
    },
    userIconColor() {
      const colors = ['gray', 'teal', 'blue-dark', 'violet', 'orange', 'yellow', 'error', 'success', 'warning']

      const first_letter_code = (this.owner.name || '?').substring(0, 1).toUpperCase().charCodeAt(0)

      const index = first_letter_code % colors.length

      return colors[index]
    },
    userNameInitials() {
      return this.owner.name
        .split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
    },
    isCafeSwitcherShown() {
      return this.selectedPage && this.selectedPage.special === 'workspace'
    },
    isProfileShown() {
      return this.selectedPage && this.selectedPage.name === 'profile'
    }
  },
  components: {
    NavbarHostButton
  }
}
</script>

<style scoped>
.supernavbar-host {
  display: flex;
  height: 100%;
  box-sizing: border-box;
  flex-direction: column;
  position: relative;
  z-index: 25;
  width: 64px;
}

.under-top-banner {
  height: calc(100% - 44px);
}

.host-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 12px;
  cursor: pointer;
  box-sizing: border-box;

  background: var(--qrw-background-base-inverse-primary);
}

.host-header:hover .host-header-logo,
.host-header-logo.active {
  border: 1px solid var(--qrw-border-base-inverse-primary);
}

.host-header-logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: block;
  object-fit: cover;
  box-sizing: border-box;
  border: 1px solid transparent;
}

.host-pages {
  display: flex;
  flex-direction: column;
  /* row-gap: 8px; */
  padding: 6px 0;
  height: 100%;
  box-sizing: border-box;
}

.host-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  background: var(--qrw-background-base-inverse-primary);
}

.host-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 6px;
}

.host-footer-divider-container {
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
}

.host-user-icon {
}

.qrw-user-avatar {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: var(--qrw-content-base-tertiary);
  background: var(--qrw-background-base-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid var(--qrw-border-base-tertiary);
}

.host-user-icon:hover {
  border: 1px solid var(--qrw-border-base-inverse-primary);
}

.host-user-icon.active {
  border: 1px solid var(--qrw-border-base-inverse-primary);
}

.host-footer-user {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 12px;
}
</style>
